module.exports = __webpack_public_path__ + "img/icon-left-arrow.7e593a11.png";